import { AGENDA_CONDITIONS_TYPE } from 'screens/oneOnOneRabbit/SettingsPage/constants';
import { AdminAgendaArray, AdminAgendaType } from 'screens/oneOnOneRabbit/SettingsPage/interfaces/AdminAgenda';
import { z } from 'zod';

import {
  createUpdateTemplateAgendaApi,
  deleteTemplateAgendaApi,
  deleteTemplateEventApi,
  getEventTemplateAgendaApi,
  getRegularTemplateAgendaApi,
  getTemplateAgendaCountApi,
} from '../api';

export const getRegularTemplateAgenda = async () => {
  try {
    const res = await getRegularTemplateAgendaApi();
    const data = AdminAgendaArray.parse(res.entity);
    const sortedData = data.sort((a, b) => a?.displayOrder - b?.displayOrder);
    return sortedData;
  } catch (error) {
    console.error('Error while fetching regular template agenda ', error);
  }
};

const eventTemplateAgendaValidator = z.record(
  z.enum([
    'REGULAR',
    'AFTER_REVIEW_PUBLISHED',
    'AFTER_JOINING_WITHIN_30_DAYS',
    'AFTER_JOINING_BETWEEN_30_TO_60_DAYS',
    'AFTER_JOINING_BETWEEN_60_TO_90_DAYS',
  ]),
  AdminAgendaArray
);

export type EventTemplateAgendaType = z.infer<typeof eventTemplateAgendaValidator>;

export const getEventTemplateAgenda = async () => {
  try {
    const res = await getEventTemplateAgendaApi();
    const data = eventTemplateAgendaValidator.parse(res.entity) ?? {};
    const sortedObj = {};
    Object.keys(data).forEach((key) => {
      sortedObj[key] = data[key].sort((a, b) => a?.displayOrder - b?.displayOrder);
    });
    return sortedObj;
  } catch (error) {
    console.error('Error while fetching event template agenda ', error);
  }
};

export const createUpdateTemplateAgenda = async ({
  agendaList,
  agendaCondition,
}: {
  agendaList: AdminAgendaType[];
  agendaCondition: AGENDA_CONDITIONS_TYPE;
}) => {
  try {
    const res = await createUpdateTemplateAgendaApi({
      agendaList,
      agendaCondition,
    });
  } catch (error) {
    console.error('Error while fetching event template agenda ', error);
  }
};

export const getTemplateAgendaCount = async ({ agendaCondition }: { agendaCondition: AGENDA_CONDITIONS_TYPE }) => {
  try {
    const res = await getTemplateAgendaCountApi({
      agendaCondition,
    });
    return res.entity;
  } catch (error) {
    console.error('Error while fetching template agenda count ', error);
  }
};

export const deleteTemplateAgenda = async ({ agendaId }: { agendaId: string | number }) => {
  try {
    const res = await deleteTemplateAgendaApi({
      agendaId,
    });
    return res.entity;
  } catch (error) {
    console.error('Error while deleting template agenda ', error);
  }
};

export const deleteTemplateEvent = async ({ eventIdToBeDeleted }: { eventIdToBeDeleted: AGENDA_CONDITIONS_TYPE }) => {
  try {
    const res = await deleteTemplateEventApi({
      eventIdToBeDeleted,
    });
    return res.entity;
  } catch (error) {
    console.error('Error while deleting template event ', error);
  }
};
